import Model from '@/models/Model.js';

export default class MeetingParticipantComment extends Model {
    static entity = 'meeting_participant_comments';

    static fields() {
        return {
            id: this.attr(null),
            meeting_id: this.attr(null),
            meeting_participant_id: this.attr(null),
            course_enrollment_id: this.attr(null),
            comment: this.attr(null),

            created_by: this.attr(null),

            ...super.fields(),

            meeting: this.belongsTo('meetings', 'meeting_id'),
            meeting_participant: this.belongsTo('meeting_participants', 'meeting_participant_id'),
            course_enrollment: this.belongsTo('course_enrollments', 'course_enrollment_id'),

            creator: this.belongsTo('users', 'created_by'),
        };
    }
}
